import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";

function CGV() {
  return (
    <div className="landing-page-component politique-confidentialite-page">
      <FrontHeader />
      <div className="page-content pb-5">
        <div className="container politique-confidentialite__container">
          <h1 className="politique-confidentialite__title">
            Conditions générales de vente
          </h1>

          <div className="politique-confidentialite__content">
            <section
              className="politique-confidentialite__section"
              aria-labelledby="cgv-commandes"
            >
              <h2 id="cgv-commandes" className="politique-confidentialite__heading">
                1. Commandes et paiements
              </h2>
              <h3 className="politique-confidentialite__subheading">
                1.1. Passer une commande :
              </h3>
              <p className="politique-confidentialite__body">
                Lorsque vous passez une commande sur notre site, vous acceptez
                d&apos;acheter les produits ou services sélectionnés aux prix et
                conditions indiqués.
              </p>
              <h3 className="politique-confidentialite__subheading">
                1.2. Paiements :
              </h3>
              <p className="politique-confidentialite__body">
                Les paiements sont traités de manière sécurisée via des méthodes
                de paiement en ligne sécurisées. Les informations de paiement
                sont cryptées et protégées.
              </p>
            </section>

            <section
              className="politique-confidentialite__section"
              aria-labelledby="cgv-livraison"
            >
              <h2 id="cgv-livraison" className="politique-confidentialite__heading">
                2. Livraison et frais de port
              </h2>
              <h3 className="politique-confidentialite__subheading">
                2.1. Livraison :
              </h3>
              <p className="politique-confidentialite__body">
                Nous nous engageons à expédier vos commandes en fonction de la
                disponibilité des produits.
              </p>
            </section>

            <section
              className="politique-confidentialite__section"
              aria-labelledby="cgv-modifications"
            >
              <h2
                id="cgv-modifications"
                className="politique-confidentialite__heading"
              >
                3. Modifications de la politique
              </h2>
              <h3 className="politique-confidentialite__subheading">
                3.1. Modifications :
              </h3>
              <p className="politique-confidentialite__body">
                Nous nous réservons le droit de modifier cette politique à tout
                moment. Les modifications seront effectives dès leur
                publication sur notre site.
              </p>
            </section>

            <section
              className="politique-confidentialite__section"
              aria-labelledby="cgv-contact"
            >
              <h2 id="cgv-contact" className="politique-confidentialite__heading">
                4. Contact
              </h2>
              <h3 className="politique-confidentialite__subheading">
                4.1. Contact :
              </h3>
              <p className="politique-confidentialite__body">
                Pour toute question concernant notre politique générale de
                ventes, veuillez nous contacter via les coordonnées fournies sur
                notre site.
              </p>
            </section>
          </div>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
}

export default CGV;
